export const SCRIBE_TOOL_NAME = 'Scribe AI';
export const CONSULT_TOOL_NAME = 'Consult AI';

const TOOL_FLAG_FIELDS = [
  { id: 'enableTextModules', storageKey: 'enable_text_modules', labelKey: 'form.enableTextModules', tools: [SCRIBE_TOOL_NAME] },
  { id: 'activateICDCodes', storageKey: 'activate_icd_codes', labelKey: 'form.activateICDCodes', tools: [SCRIBE_TOOL_NAME, CONSULT_TOOL_NAME] },
];

const STANDARD_CHECKBOXES = [
  { id: 'urgent', labelKey: 'form.markAsUrgent' },
  { id: 'isPrivate', labelKey: 'form.isPrivate' },
];

const isAllowed = (toolName, tools) => tools.includes(toolName);

export const FLAG_STORAGE_KEYS = TOOL_FLAG_FIELDS.map(({ storageKey }) => storageKey);

export const emptyToolFlags = () =>
  Object.fromEntries(TOOL_FLAG_FIELDS.map(({ id }) => [id, false]));

export const getFormCheckboxes = (toolName) => [
  ...TOOL_FLAG_FIELDS.filter((field) => isAllowed(toolName, field.tools)),
  ...STANDARD_CHECKBOXES,
];

export const getCheckboxGridClass = (count) => {
  if (count === 3) return 'grid-cols-3';
  if (count >= 4) return 'grid-cols-2 md:grid-cols-4';
  return 'grid-cols-2';
};

export const initToolFlags = (toolName, draftFormData, readBoolean) =>
  Object.fromEntries(
    TOOL_FLAG_FIELDS.map(({ id, storageKey, tools }) => [
      id,
      isAllowed(toolName, tools) ? (draftFormData?.[id] ?? readBoolean(storageKey)) : false,
    ])
  );

export const resolveToolFlags = (toolName, flags = {}) =>
  Object.fromEntries(
    TOOL_FLAG_FIELDS.map(({ id, tools }) => [
      id,
      isAllowed(toolName, tools) ? Boolean(flags[id]) : false,
    ])
  );

export const persistToolFlags = (toolName, flags) => {
  const resolved = resolveToolFlags(toolName, flags);
  TOOL_FLAG_FIELDS.forEach(({ id, storageKey }) => {
    localStorage.setItem(storageKey, String(resolved[id]));
  });
};

export const toCreateRecordFlags = (flags) => ({
  enableTextModules: flags.enableTextModules,
  activateIcdCodes: flags.activateICDCodes,
});
